import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accountapply" }
const _hoisted_2 = { class: "btn-content" }

import {reactive, ref} from "vue";
import ZCell from "@/components/ZCell/ZCell.vue";
import {onMounted} from "vue";
import {useRouter} from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'accountapply',
  setup(__props) {

const router=useRouter();
onMounted(()=>{
  document.title='入会申请'
  // document.title='内容失效'
})

const form=reactive({
  companyName:'',//公司名称
  longinAccount:'',
  longoutPassword:'',
  contactPhone:'',
  contactName:'',//法人名称
  repeatPass:''
})
const gotoPage=(path:string)=>{
  router.push('/'+path)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoPage('accountdetail?type=1')))
      }, "企业入会申请"),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (gotoPage('personapplydetail')))
      }, "个人入会申请"),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (gotoPage('accountlist'))),
        style: {"background":"#fcbf64"}
      }, "入会申请列表")
    ])
  ]))
}
}

})